import { j as c } from "../../../jsx-runtime-p91LotPX.mjs";
import { f as d } from "../../../immer.esm-DKj4WCmc.mjs";
import { a as h, t as T } from "../../../table-XsUAem3c.mjs";
import { PaginationTitle as x } from "./Title/PaginationTitle.js";
import { StyledPagination as j } from "./style.js";
function U(s) {
  const {
    handlePageChange: r,
    tablePaginationProps: t
  } = s, [n, l] = h(T);
  function m(...e) {
    const [o, u] = e;
    return /* @__PURE__ */ c.jsx(x, { total: o, range: u });
  }
  function i(...e) {
    const [o] = e;
    l((g) => d(g, (a) => (a.currentPage = o, a))), r == null || r(...e);
  }
  const f = t != null && t.total ? t.total : n.bulk_records, p = t != null && t.current ? t == null ? void 0 : t.current : n.currentPage;
  return /* @__PURE__ */ c.jsx(j, { defaultCurrent: 1, total: f, showTitle: !0, onChange: i, current: p, showSizeChanger: !1, showQuickJumper: !0, showTotal: m, ...t });
}
export {
  U as TablePagination
};
//# sourceMappingURL=TablePagination.js.map
